import classNames from 'classnames';
import { ForwardedRef, HTMLAttributes, ReactNode } from 'react';

import styles from '../../styles/themes/jeu-aide-machine-theme.module.css';

interface JeuAideMachineThemeProps extends HTMLAttributes<HTMLDivElement> {
    className?: string | null;
    children?: ReactNode;
}

function JeuAideMachineTheme({
    children = null,
    className = null,
    ref = null,
    ...props
}: JeuAideMachineThemeProps & { ref?: ForwardedRef<HTMLDivElement> | null }) {
    return (
        <div className={classNames([className, styles.container])} ref={ref} {...props}>
            {children}
        </div>
    );
}

export default JeuAideMachineTheme;
